
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium_contributions",
      function () {
        return require("private-next-pages/premium_contributions/index.tsx");
      }
    ]);
  